import React from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'
import { Typography } from '@mui/material';

export default function ColorPicker(props) {
  const [open, setOpen] = React.useState(false);
  const [color, setColor] = React.useState(props.color);

  React.useEffect(() => {
    if (!color) {
      setColor("#1ff89e");
    } else {
      setColor(color);
    }
    
  }, [color]);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (color) => {
    setColor(color.hex);
    
    props.handleChange({target: {
      name: props.name,
      value: color.hex
    }});
  };

  const styles = reactCSS({
    'default': {
      color: {
        width: '36px',
        height: '18px',
        borderRadius: '2px',
        // background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
        background: `${color}`,
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
      label: {
        align: 'center',
        margin: '2px 5px 0px 10px',
        width: '100%',
        fontsize: '2px'
      },
      component: {
        margin: '12px 0px 7px 0px',
        display: 'flex',
      },
    },
  });

  return (
    <div style={styles.component}>
      <div style={styles.swatch} onClick={handleClick}>
        <div style={styles.color} />
      </div>
      <span style={styles.label}>
        <Typography variant="body1">{props.label}</Typography>
      </span>
      {open ? <div style={styles.popover}>
        <div style={styles.cover} onClick={handleClose} />
        <SketchPicker color={color} onChange={handleChange} disableAlpha={true} />
      </div> : null}
    </div>
  )
}


